import React, { useState, useEffect, useCallback } from 'react';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import FuelEntity from './FuelEntity';
import api from 'services';

const Fuel = () => {
    const [fuel, setFuel] = useState([]);
    const [updating, setUpdating] = useState(false);

    const getFuelList = useCallback(async () => {
        const result = await api.fuel.fetchList();
        if (result.status === 200) {
            setFuel(result.data);
        }
    }, []);

    useEffect(() => {
        getFuelList();
    }, []);

    const updateAll = useCallback(async () => {
        setUpdating(true);
        const result = await api.fuel.updateAll();

        if (result.status === 200) {
            setUpdating(false);
            await getFuelList();
        }
    }, []);

    return (
        <div className='container'>
            <div className='row'>
                <div className='col-md-12 text-center m-v-1'>
                    {
                        updating ?
                            <p>Updating...</p>
                            :
                            <RaisedButton
                                label='Update all'
                                primary
                                onClick={updateAll}
                                style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                                buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                labelStyle={{ fontSize: '11px' }}
                            />
                    }
                </div>
            </div>
            <h4 className='text-center color-common'>Fuel</h4>
            <Table selectable={false} className='fuel-table'>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow style={{ borderBottom: '4px solid rgb(224, 224, 224)' }}>
                        <TableHeaderColumn>Name</TableHeaderColumn>
                        <TableHeaderColumn>IFO 180</TableHeaderColumn>
                        <TableHeaderColumn>IFO 380</TableHeaderColumn>
                        <TableHeaderColumn>MGO</TableHeaderColumn>
                        <TableHeaderColumn>VLSFO</TableHeaderColumn>
                        <TableHeaderColumn>ULSFO</TableHeaderColumn>
                        <TableHeaderColumn>LSMGO</TableHeaderColumn>
                        <TableHeaderColumn>Date</TableHeaderColumn>
                    </TableRow>
                </TableHeader>

                <TableBody displayRowCheckbox={false}>
                    {
                        fuel.length ?
                            fuel.map(f => (
                                <FuelEntity
                                    data={f}
                                    key={`fuel_price-${f._id}`}
                                    getFuelList={getFuelList}
                                    type='mpp'
                                />
                            ))
                            : 'No data'
                    }
                </TableBody>
            </Table>
        </div>
    );
};

export default Fuel;



// WEBPACK FOOTER //
// ./app/components/Fuel/index.js